module.exports = __webpack_public_path__ + "img/title-bg.3f299728.png";